export default {
	createPin({dispatch}, [pinnedUserId]) {
		return dispatch('request', {
			url: `/pins`,
			method: 'post',
			data: {
				pinnedUserId,
			}
		})
	},
	cancelPin({dispatch}, [pinsId]) {
		return dispatch('request', {
			url: `/pins/${pinsId}/cancel`,
			method: 'post',
		})
	},
	handlePin({dispatch}, [pinsId]) { //invited pinned user
		return dispatch('request', {
			url: `/pins/${pinsId}/handle`,
			method: 'post',
		})
	}
}
